import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
    const keycloak = JSON.parse(localStorage.getItem('keycloak') || '{}');

    if (!keycloak?.authenticated) {
        return <Navigate to="/not-allowed" replace />;
    }
    return children;
};
  
export default PrivateRoute;